/**
 * アスペクト比の呼称マスタ
 */
// アスペクト比の代表的な用途 (アスペクト比一覧モーダルのキャプション用)。
// ASPECT_RATIO_LABELS (形状の呼び名) とは役割が異なり、こちらは「何に使う比率か」を示す。
export const ASPECT_RATIO_USE_CASES: Record<string, string> = {
  '1:1': 'スクエア・SNS投稿',
  '16:9': '動画',
  '9:16': '縦型動画',
  '4:3': 'プレゼン資料',
  '3:4': 'ポートレート',
  '3:2': '写真',
  '2:3': 'ポスター',
  '4:5': 'SNSフィード',
  '1.91:1': 'インフィード広告',
  '1:1.91': 'インフィード広告（縦）',
  '6:5': 'レクタングルバナー',
  '728:90': 'ビッグバナー',
  '320:50': 'モバイルバナー',
  '4:1': '横長バナー',
  '1:4': '縦長バナー',
  '8:1': 'ビルボード広告',
  '1:8': 'スカイスクレイパー広告',
};

/**
 * 比率一覧で表示する解像度の例（幅・高さ、px）。生成サイズや媒体の入稿条件ではない。
 * 16:9 / 9:16 / 4:3 / 3:4 / 1.91:1 / 1:1.91 は画像編集の既存プリセットから採用。
 * 1:1 は SNS フィード (LINE・TikTok 1080) とレスポンシブ・X (1200) の規定値。
 * その他は比率に合う表示用の寸法例。1.91:1 の 1200×628 は媒体で用いる近似値。
 */
export const ASPECT_RATIO_EXAMPLE_RESOLUTIONS: Record<string, ReadonlyArray<readonly [number, number]>> = {
  '1:1': [[1080, 1080], [1200, 1200]],
  '16:9': [[1280, 720], [1920, 1080]],
  '9:16': [[720, 1280], [1080, 1920]],
  '4:3': [[800, 600], [1024, 768]],
  '3:4': [[600, 800], [768, 1024]],
  '3:2': [[1200, 800]],
  '2:3': [[800, 1200]],
  '4:5': [[1080, 1350]],
  '1.91:1': [[1200, 628]],
  '1:1.91': [[628, 1200]],
  '6:5': [[300, 250]],
  '728:90': [[728, 90]],
  '320:50': [[320, 50], [1280, 200]],
  '4:1': [[1200, 300]],
  '1:4': [[300, 1200]],
  '8:1': [[1600, 200]],
  '1:8': [[200, 1600]],
};

export const ASPECT_RATIO_LABELS: Record<string, string> = {
  '728:90': 'ビッグバナー',
  '320:50': 'モバイルバナー',
  '1:1': '正方形',
  '16:9': 'ハイビジョン',
  '9:16': '縦型動画',
  '4:3': 'スタンダード',
  '3:4': 'スタンダード（縦型）',
  '3:2': '横長',
  '2:3': '縦長',
  '4:5': '4:5',
  '4:1': '横長バナー',
  '1:4': '縦長バナー',
  '8:1': '超横長バナー',
  '1:8': '超縦長バナー',
  '1.91:1': 'SNS広告／OGP',
  '1:1.91': 'SNS広告／OGP（縦型）',
  '6:5': 'レクタングルバナー',
};

/**
 * アスペクト比の表示用ラベルを返す
 * 例: '16:9' → '16:9（ハイビジョン）'
 * 呼称がない場合はそのまま返す
 */
export function getAspectRatioLabel(ratio: string): string {
  const label = ASPECT_RATIO_LABELS[ratio];
  if (!label || label === ratio) return ratio;
  return `${ratio}（${label}）`;
}
